import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isInspiraWhatsAppUrl, openTrackedWhatsAppUrl, recordLandingPageView } from '../lib/tracking/whatsapp';
import { persistUtmParamsFromCurrentUrl } from '../lib/tracking/utm';

export default function UTMTracker() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return;
    persistUtmParamsFromCurrentUrl();
    if (location.pathname === '/' || location.pathname === '/criar-musica-personalizada') {
      void recordLandingPageView(location.pathname === '/' ? 'homepage' : 'meta_ads_landing');
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (event.defaultPrevented || event.button !== 0) return;
      const target = event.target;
      if (!(target instanceof Element)) return;

      const anchor = target.closest('a[href]');
      if (!(anchor instanceof HTMLAnchorElement)) return;
      // Volta à conversa existente sem injetar a mensagem padrão do site.
      if (anchor.hasAttribute('data-whatsapp-plain')) return;
      if (!isInspiraWhatsAppUrl(anchor.href)) return;

      event.preventDefault();
      void openTrackedWhatsAppUrl(anchor.href, { newTab: anchor.target === '_blank' });
    };

    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, []);

  return null;
}
